import { UserPresenter } from '@app/modules/users/user-presenter';
import get from 'lodash-es/get';

export class CurrentUser {
    static $errorHandler: any;
    static $eventEmitter: any;
    static $userFetcher: any;
    static $toast: any;
    static _currentUser: any;

    /**
     * @param {*} $errorHandler
     * @param {EventEmitterService} $eventEmitter
     * @param {$rootScope.Scope} $rootScope
     * @param {UserFetcher} $userFetcher
     * @param {*} $toast
     */
    static init($errorHandler, $eventEmitter, $rootScope, $userFetcher, $toast) {
        CurrentUser.$errorHandler = $errorHandler;
        CurrentUser.$eventEmitter = $eventEmitter;
        CurrentUser.$userFetcher = $userFetcher;
        CurrentUser.$toast = $toast;

        CurrentUser._currentUser = UserPresenter.attach(get(window, 'CareLineLive.user'));

        $eventEmitter.on($rootScope, $userFetcher.registeredSuccessEvents, ($event, { id }) => {
            console.log('id', id, get(CurrentUser, '_currentUser.id'));

            if (id === get(CurrentUser, '_currentUser.id')) {
                CurrentUser._fetchCurrentUser();
            }
        });
    }

    /**
     * @return {Promise}
     * @private
     */
    static _fetchCurrentUser() {
        return CurrentUser.$userFetcher.current().then(response => {
            CurrentUser._currentUser = UserPresenter.attach(get(response, 'data'));

            return CurrentUser._currentUser;
        });
    }

    /**
     * @return {User}
     */
    static get currentUser() {
        return CurrentUser._currentUser;
    }

    static get id() {
        return get(CurrentUser, '_currentUser.id');
    }

    static get value() {
        return CurrentUser.currentUser;
    }
}

CurrentUser.init.$inject = ['$errorHandler', '$eventEmitter', '$rootScope', '$userFetcher', '$toast', '$userFetcher'];
